type BrowserEnv = ImportMetaEnv & Record<string, string | undefined>;

export function readEnv(key: string, fallback = ''): string {
  return (import.meta.env as BrowserEnv)[key] || fallback;
}

export function readLegacyEnv(viteKey: string, legacyKey: string, fallback = ''): string {
  return readEnv(viteKey, readEnv(legacyKey, fallback));
}
